import { PriceSimulationFormSchema } from '../schemas/priceSimulationFormSchema';

export const getTrackableFormValues = (formstate: PriceSimulationFormSchema) => {
  const { isApiPostalCodeCityValid: _isApiPostalCodeCityValid, ...legallyAllowedFormState } = formstate ?? {};
  return legallyAllowedFormState;
};
